import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { DeveloperGuide } from './pages/DeveloperGuide';
import { PartnerRegistration } from './components/PartnerRegistration';
import { PartnerLogin } from './components/PartnerLogin';
import { SmartHouse } from './pages/SmartHouse';
import { SmartManufacturing } from './pages/SmartManufacturing';
import { SmartHospitality } from './pages/SmartHospitality';
import { SmartCommercialLighting } from './pages/SmartCommercialLighting';
import { AboutUs } from './pages/AboutUs';
import { ContactUs } from './pages/ContactUs';
import { Platform } from './pages/Platform';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import './App.css';

const ProductGuide = lazy(() =>
  import('./pages/ProductGuide').then((m) => ({ default: m.ProductGuide }))
);
const ApiDocumentation = lazy(() =>
  import('./pages/ApiDocumentation').then((m) => ({ default: m.ApiDocumentation }))
);
const PlatformIotCloud = lazy(() =>
  import('./pages/platform/PlatformIotCloud').then((m) => ({ default: m.PlatformIotCloud }))
);
const PlatformFirmwareSdk = lazy(() =>
  import('./pages/platform/PlatformFirmwareSdk').then((m) => ({ default: m.PlatformFirmwareSdk }))
);
const PlatformDashboard = lazy(() =>
  import('./pages/platform/PlatformDashboard').then((m) => ({ default: m.PlatformDashboard }))
);
const PlatformMobileApps = lazy(() =>
  import('./pages/platform/PlatformMobileApps').then((m) => ({ default: m.PlatformMobileApps }))
);
const PlatformApisIntegrations = lazy(() =>
  import('./pages/platform/PlatformApisIntegrations').then((m) => ({
    default: m.PlatformApisIntegrations,
  }))
);
const PlatformSecurity = lazy(() =>
  import('./pages/platform/PlatformSecurity').then((m) => ({ default: m.PlatformSecurity }))
);
const PlatformDeviceManagement = lazy(() =>
  import('./pages/platform/PlatformDeviceManagement').then((m) => ({
    default: m.PlatformDeviceManagement,
  }))
);

const PageFallback = () => (
  <div className="main-content" style={{ padding: '2rem', textAlign: 'center' }}>
    <p className="body-text">Loading…</p>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product-guide" element={<ProductGuide />} />
            <Route path="/developer-guide" element={<DeveloperGuide />} />
            <Route path="/api-documentation" element={<ApiDocumentation />} />
            <Route path="/partner-registration" element={<PartnerRegistration />} />
            <Route path="/partner-login" element={<PartnerLogin />} />
            <Route path="/smart-house-real-estate" element={<SmartHouse />} />
            <Route path="/smart-manufacturing" element={<SmartManufacturing />} />
            <Route path="/smart-hospitality" element={<SmartHospitality />} />
            <Route path="/smart-commercial-lighting" element={<SmartCommercialLighting />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/platform/iot-cloud" element={<PlatformIotCloud />} />
            <Route path="/platform/firmware-sdk" element={<PlatformFirmwareSdk />} />
            <Route path="/platform/dashboard" element={<PlatformDashboard />} />
            <Route path="/platform/mobile-apps" element={<PlatformMobileApps />} />
            <Route path="/platform/apis-integrations" element={<PlatformApisIntegrations />} />
            <Route path="/platform/security" element={<PlatformSecurity />} />
            <Route path="/platform/device-management" element={<PlatformDeviceManagement />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
